import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PlayerDto } from "app/models";
import { PlayerService, UtilsService } from "app/services";

@Component({
    selector: 'tactic-player-general',
    templateUrl: './tactic-player-general.component.html',
    styleUrls: ['./tactic-player-general.component.scss'],
})
export class TacticPlayerGeneral implements OnInit {
    private useRealSkills: boolean;
    
    @Input() player: PlayerDto;

    @Input()
    set displayRealSkills(val: boolean) {
        this.useRealSkills = val;
    }

    get displayRealSkills(): boolean {
        return this.useRealSkills;
    }

    @Output() changeMode = new EventEmitter<boolean>();
    
    constructor(private utils: UtilsService, private playerService: PlayerService) {
    }

    ngOnInit(): void {
    }

    getAgeLabel(): string {
        return this.utils.getAgeLabel(this.player.age);
    }

    getPlayerPositionLabel() {
        return this.playerService.formatPlayerPosition(this.player);
    }

    changeDisplaySkillsMode(val: boolean) {
        this.displayRealSkills = val;
        this.changeMode.emit(val);
    }

}